"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import {
  GA4DataLayer,
  GA4DataLayerFn,
} from "@packages/lib/utlils/helper-function";
import { GAConstants } from "@packages/shared-components/services/constants";

// Define the interface for the individual tab
interface TabDataProps {
  sectionName: string;
  sectionLink: string;
  count?: number;
  sectionId: string;
}

// Define the interface for the props passed into the TabViewComponents
interface TabViewComponentsProps {
  sectionId?: string;
  tabSectionList: TabDataProps[]; // This will be an array of TabDataProps
  scholarshipName?: string;
  commonGAAttrs?: any;
}

const TabViewComponents: React.FC<TabViewComponentsProps> = ({
  tabSectionList,
  scholarshipName,
  commonGAAttrs,
}) => {
  const pathname = usePathname();
  const foundIndex =
    tabSectionList?.findIndex((tab) => {
      const tabPath = tab.sectionLink.split("?")[0];
      const currentPath = pathname.split("?")[0];
      const tabSegments = tabPath.split("/").filter(Boolean);
      const currentSegments = currentPath.split("/").filter(Boolean);
      return tabSegments.every((seg, i) => currentSegments[i] === seg);
    }) ?? -1;
  const activeIndex = scholarshipName ? -1 : foundIndex;

  const handleTabClick = (
    e: React.MouseEvent,
    sectionName: string,
    index: number,
  ) => {
    if (activeIndex === index) {
      e.preventDefault();
      return;
    }
    GA4DataLayer({
      ...commonGAAttrs,
      event: GAConstants.track_event,
      event_name: "tab_click",
      page_section: "header",
      click_text: sectionName,
    });
  };

  return (
    <>
      {tabSectionList && (
        <section className="bg-white border-b border-grey-200 overflow-x-auto snap-x snap-mandatory px-[16px] py-[8px] md:px-[20px] xl:px-0 lg:overflow-hidden">
          <div className="max-w-container mx-auto">
            <div className="flex gap-[8px] whitespace-nowrap lg:flex-wrap">
              {tabSectionList?.map((item, index) => (
                <Link
                  href={item.sectionLink}
                  className={`btn btn-black-outline ${activeIndex === index ? "!bg-grey300 !text-white" : ""}`}
                  key={index}
                  onClick={(e) => handleTabClick(e, item?.sectionName, index)}
                >
                  {item?.sectionName}
                  {item?.count && (
                    <span className="bg-negative-default text-white rounded-[24px] p-[2px] ml-[8px]">
                      {item?.count}
                    </span>
                  )}
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default TabViewComponents;
